import React from 'react';
// import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { actions } from '../actions/events';
import EventListTable from '../components/features/EventListTable';
import { getEventsById } from '../reducers/events/byId';
import { getIsFetching } from '../reducers/events/isFetching';
import { getEventsLatest } from '../reducers/events/latest';
import { getLocationQuery } from '../reducers/location';

class LatestEventsContainer extends React.PureComponent {
  static propTypes = {
  };

  static defaultProps = {
  };

  componentDidMount() {
    if (!this.props.eventsLatest.length) {
      this.props.apiEventsLatestRequest();
    }
  }

  render() {
    const {
      eventsLatest,
      ...rest
    } = this.props;

    return (
      <EventListTable
        data={eventsLatest}
        {...rest}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  eventsLatest: getEventsLatest(state).map(id => getEventsById(state)[id]),
  isFetching: getIsFetching(state),
  locationQuery: getLocationQuery(state),
  ...ownProps,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  apiEventsLatestRequest: actions.apiEventsLatestRequest,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(LatestEventsContainer);



// WEBPACK FOOTER //
// ./src/containers/LatestEventsContainer.js